import {Component, DOCUMENT, Inject, inject, Input, OnInit} from '@angular/core';
import { SystemResponse } from '../../../features/dashboard/models/SystemsModel';
import { NavigationEnd, Router } from '@angular/router';
import { SidebarService } from '../../../core/services/sidebar/sidebar-service';
import { filter } from 'rxjs';
import { KeyStorageUtil } from '../../utils/keystorage';
import { UtilCatService } from '../../utils/UtilCatService';
import { environment } from '../../../../enviroments/enviroment';

@Component({
  selector: 'app-sidebar',
  imports: [
  ],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css',
})
export class Sidebar implements OnInit {


  isAdmin: boolean = UtilCatService.isSuperUser();
  ngOnChanges() {
    if (this.currentPath !== '/') {
      this.sidebarService
        .getSystems(UtilCatService.isSuperUser())
        .subscribe((systems) => {
          this.sidebarSystems = systems;
        });
    }
  }

  constructor(
    private router: Router,
    private utilCatService: UtilCatService

  ) {
    this.currentPath = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentPath = event.url;
      });

    if (this.items.some((item) => this.currentPath.includes(item.url))) {
      this.isDropdownOpen = true;
    }
  }
  protected sidebarService = inject(SidebarService);

  ngOnInit() {
    this.sidebarService.systemsUpdated$.subscribe(updatedSystems => {
      this.sidebarSystems = updatedSystems;
    });

    if (this.currentPath !== '/') {
      this.sidebarService.getSystems(UtilCatService.isSuperUser()).subscribe((systems) => {
        this.sidebarSystems = systems;
      });
    }
  }
  //sidebar logic
  closeSidebar() {
    this.sidebarService.close();
  }
  //user data
  userNew: boolean = false;

  //config
  items = [
    { nombre: 'Sistema', url: '/sistemas', icon: 'apps' },
    { nombre: 'Menú sistemas', url: '/menu-system-config', icon: 'menu' },
    { nombre: 'Perfiles', url: '/profile-config', icon: 'manage_accounts' },
    { nombre: 'Usuarios', url: '/user-config', icon: 'people' },
  ];

  isDropdownOpen: boolean = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  navigateToUrl(url: string) {
    this.router.navigate([url]);
  }

  sidebarSystems: SystemResponse[] = [];

  handleEnterSystem(item: SystemResponse) {
    this.utilCatService.enterTheSystem(item);
  }

  @Input() currentPath: string = '';
}
